import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { registerAdmin } from '../../services/adminService';
import { toast } from 'react-toastify';
import PasswordField from '../../components/PasswordField';

const AdminRegister = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: '',
        phoneNumber: ''
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.password !== formData.confirmPassword) {
            toast.error('Passwords do not match!');
            return;
        }
        setLoading(true);
        try {
            const { confirmPassword, ...adminData } = formData;
            await registerAdmin(adminData);
            toast.success('Admin registered successfully!');
            navigate('/admin-login');
        } catch (error) {
            toast.error(error.response?.data?.message
                || 'Registration failed!');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="premium-auth-page">
            <div className="container py-4">
                <div className="premium-auth-card premium-auth-card-user">
                    <div className="premium-auth-header">
                        <div className="premium-auth-badge">🔐</div>
                        <h2 className="premium-auth-title">Admin Registration</h2>
                        <p className="premium-auth-subtitle">Create your administrative profile</p>
                    </div>
                    <div className="premium-auth-body">
                        <form onSubmit={handleSubmit} className="premium-auth-form">
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label fw-bold"
                                                    style={{ color: '#8B0000' }}>
                                                    First Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="firstName"
                                                    placeholder="First name"
                                                    value={formData.firstName}
                                                    onChange={handleChange}
                                                    required
                                                    style={{ borderColor: '#FFD700' }}
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label fw-bold"
                                                    style={{ color: '#8B0000' }}>
                                                    Last Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="lastName"
                                                    placeholder="Last name"
                                                    value={formData.lastName}
                                                    onChange={handleChange}
                                                    required
                                                    style={{ borderColor: '#FFD700' }}
                                                />
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label fw-bold"
                                                style={{ color: '#8B0000' }}>
                                                Email Address
                                            </label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                name="email"
                                                placeholder="Admin email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                                style={{ borderColor: '#FFD700' }}
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label fw-bold"
                                                style={{ color: '#8B0000' }}>
                                                Phone Number
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="phoneNumber"
                                                placeholder="Phone number"
                                                value={formData.phoneNumber}
                                                onChange={handleChange}
                                                style={{ borderColor: '#FFD700' }}
                                            />
                                        </div>

                                        <PasswordField
                                            label="Password"
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            placeholder="Min 8 characters"
                                            required
                                            className="form-control"
                                            inputClassName=""
                                        />

                                        <PasswordField
                                            label="Confirm Password"
                                            name="confirmPassword"
                                            value={formData.confirmPassword}
                                            onChange={handleChange}
                                            placeholder="Confirm password"
                                            required
                                            className="form-control"
                                            inputClassName=""
                                        />

                                        <button
                                            type="submit"
                                            className="btn w-100 fw-bold py-2"
                                            style={{
                                                background: 'linear-gradient(135deg, #8B0000 0%, #B22222 100%)',
                                                color: '#FFD700',
                                                border: 'none',
                                                borderRadius: '8px'
                                            }}
                                            disabled={loading}>
                                            {loading
                                                ? 'Registering...'
                                                : '🔐 Register Admin'}
                                        </button>
                                    </form>

                        <div className="premium-auth-links">
                            <p>Already registered?
                                <Link to="/admin-login">Login here</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminRegister;